import TextButton from 'LuxKit/Button/TextButton'
import React from 'react'

interface Props {
  kind: 'primary' | 'secondary' | 'tertiary'
}

function SearchTilePrimaryActionButton({ kind }: Props) {
  return <TextButton nonInteractable kind={kind}>View offer</TextButton>
}

export default SearchTilePrimaryActionButton
